<template>
    <div class="card">
        <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
            <b class="text-16">{{ fitter.mobile == 1 ? 'Fitting' : 'Shipping' }} information</b>
        </div>
        <div class="card-body">
            <label
                for="same_as_billing"
                class="toggle-label d-inline-block cursor-pointer my-2"
                :class="{'active': sameAsBilling}"
                @click="toggleShipping"
            >
                {{ fitter.mobile == 1 ? 'Fitting' : 'Shipping' }} address same as billing address?
            </label>
            <Field id="same_as_billing" name="same_as_billing" type="checkbox" class="d-none"/>
            <shipping-fields
                v-if="sameAsBilling == false && (fitter.mobile == 1 || this.$parent.$parent.basket.home_delivery == 1)"
                :session-postcode="sessionPostcode"
                :addresses="addresses"
                :errors="errors"
                @inputShippingAddressManually="this.$emit('inputShippingAddressManually')"
            ></shipping-fields>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    
    export default {
        props: ['fitter', 'sessionPostcode', 'addresses', 'sameAsBilling', 'errors'],
        emits: ['toggleShippingFields','inputShippingAddressManually'],
        components: { Field, ErrorMessage },
        data() {
            return {
            }
        },
        mounted() {

        },
        methods: {
            toggleShipping() {
                this.$emit('toggleShippingFields');
            }
        }
    }
</script>